import axios from 'axios'
import rutas from '@/assets/utils/rutas.json'

const API = rutas.axios + 'api'

export const paquetesService = {
  // Nueva consulta para tabla de paquetes preventivos (modelo enfprevent_enfprevent)
  async getAll(params){
    const query = `
      query GetPaquetesPrevTabla(
        $search: String, $estado: String, $estadoActivo: String, $tipoPaquete: String,
        $fechaDesde: Date, $fechaHasta: Date, $page: Int!, $pageSize: Int!
      ){
        paquetesPrevTabla(
          params: { search: $search, estado: $estado, estadoActivo: $estadoActivo, tipoPaquete: $tipoPaquete,
                    fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, page: $page, pageSize: $pageSize }
        ){
          total
          data{
            id
            token
            codigo
            fecha_creacion
            ultimo_cambio
            json_paquete
            estadoactivo
            estado
          }
        }
      }
    `
    const variables = { ...params }
    const { data } = await axios.post(API, { query, variables })
    const payload = data?.data?.paquetesPrevTabla || { total:0, data:[] }
    return { total: payload.total || 0, data: payload.data || [] }
  },

  async getById(id){
    const query = `
      query GetPaquetePrevById($id: ID!){
        paquetePrevById(id: $id){
          id
          token
          codigo
          json_paquete
          estado
          estadoactivo
        }
      }
    `
    const variables = { id }
    const { data } = await axios.post(API, { query, variables })
    return data?.data?.paquetePrevById || null
  },

  async actualizarJsonPaquete(id, jsonString){
    const query = `
      mutation ActualizarPaquetePrev($id: ID!, $json: String!){
        actualizarPaquetePreventivoJson(id: $id, json: $json){ status message id }
      }
    `
    const variables = { id, json: jsonString }
    const { data } = await axios.post(API, { query, variables })
    return data?.data?.actualizarPaquetePreventivoJson || null
  },

  async setEstado(id, estado){
    const query = `
      mutation SetEstadoPaquetePrev($id: ID!, $estado: String!){
        setEstadoPaquetePreventivo(id: $id, estado: $estado){ status message }
      }
    `
    const variables = { id, estado }
    const { data } = await axios.post(API, { query, variables })
    return data?.data?.setEstadoPaquetePreventivo || null
  },

  async setEstadoActivo(id, estadoActivo){
    const query = `
      mutation SetEstadoActivoPaquetePrev($id: ID!, $estadoActivo: String!){
        setEstadoActivoPaquetePreventivo(id: $id, estadoActivo: $estadoActivo){ status message }
      }
    `
    const variables = { id, estadoActivo }
    const { data } = await axios.post(API, { query, variables })
    return data?.data?.setEstadoActivoPaquetePreventivo || null
  },

  async getByToken(token){
    const query = `
      query GetPaquetePrevByToken($token: String!){
        paquetePrevByToken(token: $token){
          id
          token
          codigo
          json_paquete
          estado
          estadoactivo
        }
      }
    `
    const variables = { token }
    const { data } = await axios.post(API, { query, variables })
    return data?.data?.paquetePrevByToken || null
  },

  async getReportePaquetes(params){
    const query = `
      query ReportePaquetesPrev(
        $search: String, $establecimiento: String!, $doctor: String,
        $estado: String, $tipoPaquete: String, $fechaDesde: Date, $fechaHasta: Date,
        
      ){
        reportePaquetesPreventivos(
          params:{ search:$search, establecimiento:$establecimiento, doctor:$doctor,
                   estado:$estado, tipoPaquete:$tipoPaquete, fechaDesde:$fechaDesde, fechaHasta:$fechaHasta
                    }
        ){
          status message dataarchivo
        }
      }
    `
    const variables = { ...params }
    const { data } = await axios.post(API, { query, variables })
    const payload = data?.data?.reportePaquetesPreventivos || null
    return payload
  },

  // Envia un solo parámetro: cadena JSON del paquete
  async enviarJsonPaquete(jsonString){
    // GraphQL mutation placeholder; el backend lo implementará.
    const query = `
      mutation CrearPaquetePreventivoJson($json: String!) {
        crearPaquetePreventivoJson(json: $json) {
          status
          message
          id
        }
      }
    `
    const variables = { json: jsonString }
    const { data } = await axios.post(API, { query, variables })
    return data?.data?.crearPaquetePreventivoJson || null
  },

  async searchSelect(term){
    if(!term || !term.trim()) return []
    const params = {
      search: term,
      page: 1,
      pageSize: 10,
      estadoActivo: '1',
    }
    const response = await this.getAll(params)
    const paquetes = response?.data || []

    return paquetes.map(paquete => {
      let jsonParsed = {}
      const raw = paquete?.json_paquete

      if (raw) {
        if (typeof raw === 'string') {
          try {
            jsonParsed = JSON.parse(raw)
          } catch (error) {
            console.error('Error parsing json_paquete', paquete?.id, error)
          }
        } else if (typeof raw === 'object') {
          jsonParsed = raw
        }
      }

      const nombre = jsonParsed?.nombre || paquete?.nombre || 'Paquete sin nombre'
      const codigo = paquete?.codigo || jsonParsed?.codigo || 'SIN-COD'

      return {
        ...paquete,
        jsonParsed,
        nombre,
        value: paquete?.id,
        text: `${codigo} - ${nombre}`,
      }
    })
  }
}
